import {CheckCircle, Clock, TrendingUp, Wallet} from 'lucide-react';

const payments = [
    {
        title: 'حقوق ماه مرداد',
        amount: '45,000,000',
        date: '1403/05/30',
        status: 'paid',
        type: 'حقوق ماهانه'
    },
    {
        title: 'پاداش پروژه ویژه',
        amount: '12,000,000',
        date: '1403/05/25',
        status: 'paid',
        type: 'پاداش'
    },
    {
        title: 'کلاس‌های اضافه',
        amount: '8,500,000',
        date: '1403/05/20',
        status: 'pending',
        type: 'ساعات اضافی'
    },
    {
        title: 'حقوق ماه تیر',
        amount: '45,000,000',
        date: '1403/04/30',
        status: 'paid',
        type: 'حقوق ماهانه'
    },
];

export default function EarningsSection() {
    const totalEarnings = '45,000,000';
    const pendingAmount = '8,500,000';
    const growthPercentage = '+15%';

    return (
        <div className=" rounded-xl shadow-sm border dark:border-gray-600 border-gray-100 p-6">
            <div className="flex items-center justify-between mb-6">
                <button className="text-sm text-blue-600 hover:text-blue-700 font-medium">
                    مشاهده تاریخچه کامل
                </button>
                <div className="flex items-center gap-2">
                    <Wallet className="w-5 h-5  "/>
                    <h2 className="text-lg font-bold  ">درآمد و پرداخت‌ها</h2>
                </div>
            </div>

            <div className="grid grid-cols-3 gap-4 mb-6">
                <div
                    className="bg-gradient-to-br from-emerald-50 to-emerald-100 rounded-lg p-4 border dark:border-gray-600 border-emerald-200">
                    <div className="flex items-center justify-end gap-2 mb-2">
                        <Wallet className="w-5 h-5 text-emerald-600"/>
                    </div>
                    <p className="text-right text-sm text-emerald-700 mb-1">درآمد این ماه</p>
                    <p className="text-right text-2xl font-bold text-emerald-900">{totalEarnings}</p>
                    <p className="text-right text-xs text-emerald-600 mt-1">تومان</p>
                </div>

                <div className="bg-gradient-to-br from-orange-50 to-orange-100 rounded-lg p-4 border dark:border-gray-600 border-orange-200">
                    <div className="flex items-center justify-end gap-2 mb-2">
                        <Clock className="w-5 h-5 text-orange-600"/>
                    </div>
                    <p className="text-right text-sm text-orange-700 mb-1">در انتظار پرداخت</p>
                    <p className="text-right text-2xl font-bold text-orange-900">{pendingAmount}</p>
                    <p className="text-right text-xs text-orange-600 mt-1">تومان</p>
                </div>

                <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-lg p-4 border dark:border-gray-600 border-blue-200">
                    <div className="flex items-center justify-end gap-2 mb-2">
                        <TrendingUp className="w-5 h-5 text-blue-600"/>
                    </div>
                    <p className="text-right text-sm text-blue-700 mb-1">رشد نسبت به ماه قبل</p>
                    <p className="text-right text-2xl font-bold text-blue-900">{growthPercentage}</p>
                    <p className="text-right text-xs text-blue-600 mt-1">افزایش درآمد</p>
                </div>
            </div>

            <div className="space-y-3">
                {payments.map((payment, index) => (
                    <div
                        key={index}
                        className="border dark:border-gray-600 border-gray-200 rounded-lg p-4 hover:shadow-md transition-all duration-200"
                    >
                        <div className="flex items-center justify-between">
                            <div className="flex items-center gap-3">
                                <div className="text-left">
                                    <p className="text-lg font-bold  ">{payment.amount}</p>
                                    <p className="text-xs  ">تومان</p>
                                </div>
                                {payment.status === 'paid' ? (
                                    <div
                                        className="px-3 py-1 bg-green-100 text-green-700 rounded-full text-xs font-medium flex items-center gap-1">
                                        <CheckCircle className="w-3 h-3"/>
                                        پرداخت شده
                                    </div>
                                ) : (
                                    <div
                                        className="px-3 py-1 bg-orange-100 text-orange-700 rounded-full text-xs font-medium flex items-center gap-1">
                                        <Clock className="w-3 h-3"/>
                                        در انتظار
                                    </div>
                                )}
                            </div>

                            <div className="text-right">
                                <h3 className="font-semibold   mb-1">{payment.title}</h3>
                                <div className="flex items-center gap-3 text-xs   justify-end">
                                    <span>{payment.date}</span>
                                    <span className="text-blue-600">{payment.type}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
